<template>
  <div class="StudyTitle">
    <div class="left">
      <div class="line"></div>
      <div class="title">{{ title }}</div>
    </div>
    <div class="bottom" @click="$emit('click')">
      <span>查看全部</span>
      <img class="icon" :src="require('@/assets/images/icon_arrow_03.png')" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudyTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="less" scoped>
.StudyTitle {
  padding: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    .line {
      width: 8px;
      height: 32px;
      background: linear-gradient(180deg, #FF7643 0%, #FF5A7A 100%);
      border-radius: 4px;
    }
    .title {
      font-weight: bold;
      margin-left: 20px;
      font-size: 32px;
      color: #333444;
    }
  }
  .bottom {
    display: flex;
    align-items: center;
    span {
      font-size: 24px;
      font-weight: 500;
      color: #999AAA;
    }
    .icon {
      margin-left: 16px;
      width: 22px;
      height: 22px;
    }
  }
}
</style>